import { createFileRoute } from '@tanstack/react-router';
import WarRoom from 'src/pages/Organization/Event/Mods/WarRoom';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/mods/$modId/',
)({
  component: WarRoom,
});
